export const parseBigInt = (value: string | number | bigint | boolean): bigint | 'NaN' => {
  try {
    return BigInt(value)
  } catch (err) {
    return 'NaN'
  }
}

export const isNaNBigInt = (value: number | bigint | string): boolean => {
  return value === 'NaN'
}
